<template>
    <div>
        <div class="row" style="text-align: center; padding: 5px;">
            <img :src="'https://thewoodlandstaxattorney.com/static/images/logo-black.png'">     
        </div>
        <nav class="panel">
            <p class="panel-heading" style="top: -20px; position: relative; text-align: center;">
                <a @click="showUserProfile = true">
                    Change Password
                </a> / <a @click="$store.dispatch('logout')">
                    Logout
                </a>                
            </p>
        </nav>
        
        <b-modal :active.sync="showUserProfile">
            <UserProfile 
                @closeModule="showUserProfile = !showUserProfile"></UserProfile>
        </b-modal>

    </div>
</template>

<script>

export default {
    components: {
    },
    data() {
        return {
            isActive: false,
            navbar: true,
            showUserProfile: false,
            showSearchBox: false,
            closeRenew: !this.getAccountActive,
            showTaskBox: false,
            showNotification: false
        }
    },
    computed: {
        
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Navbar/Index.vue